if(instagram_enable) {
    if (typeof(instagram_token) != 'undefined' && typeof(instagram_id) != 'undefined' ) {
        if ($('.instagram-block-footer #instafeed').length) {
            var feed = new Instafeed({
                get: 'user',
                userId: instagram_id,
                accessToken: instagram_token,
                limit: $('.instagram-block-footer #instafeed').attr('data-count'),
                template: '<div class="insta-item"><a href="{{link}}"><img src="{{image}}" /></a></div>',

                after: function () {
                    external();
                },
            });
            feed.run();

            function external() {
                jQuery(document).ready(function ($) {
                    $('#instafeed a').attr('target', '_blank');
                });
            }
        }

        if ($('.instagram_section #instafeed').length) {
            let grid_classes = $('.instagram_section #instafeed').attr("data-count") == 4 ? 'col-xl-3 col-lg-3 col-md-3 col-6' : 'col-xl-2 col-lg-2 col-md-4 col-6';
            var feed = new Instafeed({
                get: 'user',
                userId: instagram_id,
                accessToken: instagram_token,
                limit: $('.instagram_section #instafeed').attr("data-count"),
                resolution: 'standard_resolution',
                template: '<div class="insta-item grid-item '+ grid_classes +'"><a href="{{link}}"><img src="{{image}}" /><div class="insta-hover"> <div class="instagram-icon"><i>+</i></div></div></a></div>',

            });
            feed.run();

            function external() {
                jQuery(document).ready(function ($) {
                    $('#instafeed a').attr('target', '_blank');
                });
            }
        }
    }
}